// Map.ts

import { __debug } from "../Debug/Debug";
import { IChatMessageFragment, IFileUpload, IFragmentNo, IIdData, IIdDataObject } from "../Interfaces";

class Map {
    fragmentNo: IFragmentNo = {};
    chatMessageData: IIdDataObject = {};

    /**
     * Maps the chat message type.
     * @param chatMessageFragment
     * @returns string
     */
    mapChatMessageType = (chatMessageFragment: IChatMessageFragment | any): string => {
        switch (chatMessageFragment.messageType) {
            case "MessageSend":
                return "You";
            case "MessageReceive":
                return chatMessageFragment.props.userName || "Bot";
            case "MessageNotify":
                return "Notify";
            default:
                return "Unknown Message Type";
        }
    };

    /**
     * Maps the chat message fragment.
     * @param chatMessageFragment
     * @returns string
     */
    mapChatMessageFragment = (chatMessageFragment: IChatMessageFragment | any): string => {
        switch (chatMessageFragment.fragmentType) {
            case "Text":
                return chatMessageFragment.props.text;
            case "Form":
                return "Submitting Form...";
            case "FileUpload":
                return "Uploading File...";
            case "Quiz":
                return "Asking Quiz...";
            case "Navigation":
                return "Navigating...";
            default:
                return "Unknown Message";
        }
    };

    /**
     * Sets fragment number on the given id.
     * @param id
     * @param fragmentNo
     */
    setFragmentNoOnId = (id: string, fragmentNo: number) => {
        this.fragmentNo[id] = fragmentNo;
    };

    /**
     * Returns fragment number if associated with the given id.
     * @param id
     * @returns number
     */
    getFragmentNoFromId = (id: string): number | undefined => {
        return this.fragmentNo[id];
    };

    /**
     * Sets data on the given id.
     * @param id
     * @param data
     */
    setDataOnId = (id: string, data: IIdData) => {
        if (!id) {
            __debug.warn(() => {
                console.warn("No id given to set the data!");
            });
            return;
        }
        this.chatMessageData[id] = data;
    };

    /**
     * Returns data if associated with the given id.
     * @param id
     * @returns IIdData
     */
    getDataFromId = (id: string): IIdData | undefined => {
        return this.chatMessageData[id];
    };

    /**
     * Maps the common attributes from the File object.
     * @param file
     */
    mapFileData = (file: File): IFileUpload => {
        return {
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type,
        };
    };
}

// export Style class instance (singleton)
export const __map = new Map();
